import React, { useEffect, useRef, useState } from "react";
import { Fade } from "react-reveal";
import { Button, Col, Table } from "react-bootstrap";
import moment from "moment";
import WithdrawModel from "./withdraw-model";
import DepositModel from "./deposit-model";
import { useDispatch, useSelector } from "react-redux";
import ButtonLoader from "Component/Common/ButtonLoader";
import { useKycStatus } from "helpers/custom-hooks";

import { Link, NavLink } from "react-router-dom";
import useToastr from "helpers/toastr";
import { useTranslation } from "react-i18next";

const Assets = ({ vault, handleRefresh, isRefresh }) => {
  // console.log("vault", assets)
  const [showModal, setshowModal] = useState(false);
  const [isDeposit, setIseDeposit] = useState(false);
  const { user } = useSelector(({ Login }) => Login);
  const { loading } = useSelector(({ Register }) => Register);
  const toastr = useToastr();
  const { t } = useTranslation();
  const isVerified = useKycStatus();

  const [selectedAsset, setSelectedAsset] = useState();

  const handlWithdraw = (obj) => {
    setSelectedAsset(obj);
    setshowModal(true);
  };

  const handlDeposit = (obj) => {
    setSelectedAsset(obj);
    setIseDeposit(true);
  };

  /**
   * Used for render the UI of assets listing table
   */

  return (
    <Col lg={12} className="my-2">
      <div className="cardBox p-3 bg-white">
        <div className="py-2 my-2 d-flex align-items-center justify-content-between">
          <div className="sectionHead text-start">
            <h4 className="m-0 py-2 fw-bold">{t("asset_list")}</h4>
          </div>

          {isVerified && (
            <div className="d-flex align-items-center gap-2">
              <Link to="/withdraw-history" className="nav-link signup_btn">
                {t("history")}{" "}
              </Link>
              <Link
                to=""
                onClick={handleRefresh}
                className="nav-link signup_btn"
              >
                {loading && isRefresh ? (
                  <ButtonLoader />
                ) : (
                  <span className="text-capitalize his-confirmed d-flex align-items-center">
                    {t("refresh")}
                  </span>
                )}
              </Link>
            </div>
          )}
        </div>

        <WithdrawModel
          show={showModal}
          onHide={() => setshowModal(!showModal)}
          selectedAsset={selectedAsset}
        />

        <DepositModel
          show={isDeposit}
          onHide={() => setIseDeposit(!isDeposit)}
          selectedAsset={selectedAsset}
        />

        <div className="table-responsive">
          <table className="table table-nowrap">
            <thead>
              <th>Icon</th>
              <th>{t("asset_name")}</th>
              <th>{t("available_balance")}</th>
              <th>{t("total_balance")}</th>
              <th>{t("actions")}</th>
            </thead>

            <tbody className="position-relative">
              {loading && isRefresh && (
                <div className="td_loader">
                  <ButtonLoader />
                </div>
              )}
              {vault?.assets.length > 0 &&
                vault?.assets.map((item, idx) => (
                  <tr key={idx}>
                    <td>
                      {item?.icon ? (
                        <img className="img-fluid" src={item?.icon} width="40%" />
                      ) : (
                        "--"
                      )}
                    </td>
                    <td>{item.id}</td>
                    <td>{item.available}</td>
                    <td>{item.total}</td>

                    {/* {
                    user?.kycDetails?.verified && */}
                    <td>
                      <div className="d-flex align-items-center gap-3 justify-content-center">
                        <Button
                          onClick={() => handlWithdraw(item)}
                          className="btn_widthdraw copy_btn"
                        >
                          <span className="text-capitalize his-confirmed">
                            {t("withdraw")}
                          </span>
                        </Button>

                        <Button
                          onClick={() => handlDeposit(item)}
                          className="btn_widthdraw copy_btn"
                        >
                          <span className="text-capitalize his-confirmed">
                            {t("deposit")}
                          </span>
                        </Button>
                      </div>
                    </td>
                    {/* } */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </Col>
  );
};

export default Assets;
